export const peopleDataLoaded = (dataLoaded, data) => ({
  type: 'DATA_LOADED',
  dataLoaded,
  data
});

export const postUpdated = (sortBy, value, filteredData, filterSelected) => ({
  type: 'UPDATE_POST_DATA',
  sortBy,
  value,
  filteredData,
  filterSelected

});

export const updateFilterSelected = (filterName, value, query) => ({
  type: 'UPDATE_FILTER_ACTIVE',
  filterName,
  value,
  query
});

export const clearFilters = (filterName, value) => ({
  type: 'CLEAR_FILTERS',
  filterName,
  value
});